import { JsonInput as MantineJsonInput } from '@mantine/core';
import type { JsonInputProps as MantineJsonInputProps } from '@mantine/core';

import type { LockedProps } from '../types';

export type JsonInputProps = Omit<MantineJsonInputProps, LockedProps>;

/**
 * ### JsonInput
 *
 * @description
 * Mantine's JsonInput minus per-call-site style overrides (see {@link LockedProps}). Label, error,
 * and description order defaults to the shared form layout; pass `inputWrapperOrder` to change it.
 *
 * @example
 * <JsonInput value={json} onChange={setJson} validationError="Invalid JSON" />
 *
 * @param props - {@link JsonInputProps}
 * @returns React component
 */
export const JsonInput = (props: JsonInputProps) => {
  return (
    <MantineJsonInput inputWrapperOrder={['label', 'input', 'error', 'description']} {...props} />
  );
};
